"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Path = exports.Circle = exports.Svg = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Svg = _styledComponents.default.svg.attrs({
  focusable: false
}).withConfig({
  displayName: "svg-elements__Svg",
  componentId: "fefkw4-0"
})([""]);

exports.Svg = Svg;

var Circle = _styledComponents.default.circle.withConfig({
  displayName: "svg-elements__Circle",
  componentId: "fefkw4-1"
})([""]);

exports.Circle = Circle;

var Path = _styledComponents.default.path.withConfig({
  displayName: "svg-elements__Path",
  componentId: "fefkw4-2"
})(["vector-effect:none;stroke-width:", " !important;"], function (props) {
  return props.strokeWidth;
});

exports.Path = Path;